// extracted by mini-css-extract-plugin
export default {"section-container":"oneRow_section-container__F91Mn"};